// extracted by mini-css-extract-plugin
export default {"tabs":"V8-z","tablist":"W8-z","tablistItem":"X8-z"};